
<!-- Add Category -->
<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>


<!-- 2nd way without modal demo -->
   <section *ngIf="trainingType.length">
    <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</section>


<app-footer></app-footer>

